import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[rlDrag]'
})
export class DragDirective {

  @Input("rlDrag") elementToDrag : HTMLElement;

  elementToX; elementToY; Xmouse; Ymouse;

  isDragging : boolean = false;

  @HostListener("mousedown", ["$event"])
  saveMouseCoordinate(e : any){
    e.preventDefault();
    this.elementToX = this.elementToY = 0;
    // get the mouse cursor position at startup:
    this.Xmouse = e.clientX;
    this.Ymouse = e.clientY;
    this.isDragging = true;
  }

  @HostListener("window:mousemove", ["$event"])
  setPosition(e){
    if(!this.isDragging) return;
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    this.elementToX = this.Xmouse - e.clientX;
    this.elementToY = this.Ymouse - e.clientY;
    this.Xmouse = e.clientX;
    this.Ymouse = e.clientY;
    // set the element's new position:
    this.elementToDrag.style.top = (this.elementToDrag.offsetTop - this.elementToY) + "px";
    this.elementToDrag.style.left = (this.elementToDrag.offsetLeft - this.elementToX) + "px";
  }

  @HostListener("window:mouseup", ["$event"])
  setNewPosition(e : any){
    this.isDragging = false;
  }
}
